(function () {
  const TARGET_PRODUCTS = [7676089991402, 8653119029482];

  const productId = window.__st?.pid
    || window.ShopifyAnalytics?.meta?.product?.id
    || null;

  if (!TARGET_PRODUCTS.includes(Number(productId))) return;

  window.addEventListener('load', function () {
    const shadeSelect = document.querySelector('select.select__select');
    const atcBtn = document.querySelector('button[name="add"].product-form__submit');

    if (!shadeSelect || !atcBtn) return;

    // Force-select "Select a shade" on load regardless of position
    Array.from(shadeSelect.options).forEach((opt, i) => {
      if (opt.text.trim() === 'Select a shade') {
        shadeSelect.selectedIndex = i;
      }
    });

    function checkSelection() {
      const selectedText = shadeSelect.options[shadeSelect.selectedIndex]?.text?.trim();
      if (selectedText === 'Select a shade') {
        atcBtn.style.display = 'none';
      } else {
        atcBtn.style.display = '';
      }
    }

    // Run on load
    checkSelection();

    // Run on every change
    shadeSelect.addEventListener('change', checkSelection);
  });

})();
